module.exports = __webpack_public_path__ + "img/social3.eb19b558.svg";